import { useCallback, useState } from 'react';

export default function useForceUpdate(): [{}, () => void] {
  const [update, updateState] = useState({});
  return [update, useCallback(() => updateState({}), [])];
}
